// src/components/FloatingModal/FloatingModal.js
import React from 'react';
import { CloseIcon } from '../../assets/icons/icons';
import './style.css';

export default function FloatingModal({
  isOpen,
  onRequestClose,
  title,
  children
}) {
  if (!isOpen) return null;

  return (
    <div className="floating-modal-overlay" onClick={onRequestClose}>
      <div className="floating-modal-content" onClick={e => e.stopPropagation()}>
        <div className="floating-modal-header">
          <h2>{title}</h2>
          <CloseIcon className="floating-modal-close" onClick={onRequestClose}/>
        </div>
        <div className="floating-modal-body">
          {children}
        </div>
      </div>
    </div>
  );
}
